document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.key-ingredients');
  if (!section) return;

  const carousel = section.querySelector('.ki-carousel');
  const prevBtn = section.querySelector('.ki-arrow[aria-label="precedente"]');
  const nextBtn = section.querySelector('.ki-arrow[aria-label="successivo"]');
  const progressActive = section.querySelector('.ki-progress__active');

  // --- FUNZIONI ---
  function updateProgress() {
    const scrollLeft = carousel.scrollLeft;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    const percent = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
    progressActive.style.width = `${percent}%`;
  }

  function scrollTo(direction) {
    const card = carousel.querySelector('.ki-card');
    if (!card) return;
    const cardWidth = card.offsetWidth + 16; // card + gap
    carousel.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
  }

  // --- EVENT LISTENERS ---
  if (prevBtn) prevBtn.addEventListener('click', () => scrollTo(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollTo(1));
  carousel.addEventListener('scroll', updateProgress);

  // --- INIT ---
  updateProgress();
});